const data = {
  "cookieBanner": {
    "fact": "Cookies",
    "slogan": "Smaakmakers.",
    "cookiesJos": "Jos eet een koekje"
  },
  "cookieBanner2025": {
    "fact": "Cookies",
    "slogan": "Privéfeestje.",
    "cookiesJos": "Jos eet een koekje",
    "body": {
      "explanation": "Coolblue deelt cookies uit wanneer je de website bezoekt. Geen gevulde koeken, wel kleine (tijdelijke) tekstbestanden. Zo hoef je niet steeds dezelfde informatie in te vullen of opnieuw te downloaden. Handig! Denk aan het onthouden van je winkelwagen of je eerder bekeken producten. Naast functionele cookies, waardoor de website goed werkt, gebruiken we ook analytische cookies om te begrijpen hoe je onze website gebruikt. Zo maken we ’m beter en klantvriendelijker. We gebruiken ook marketing cookies voor persoonlijke advertenties die passen bij jouw interesses. Daarvoor delen we soms gegevens met onze partners.",
      "readMoreExplanation": "Meer weten? Lees <readMorePrivacy>hier</readMorePrivacy> alles over ons cookie- en privacyverklaring. Hieronder kun je aangeven of je alles accepteert, weigert of je kunt je cookies zelf instellen. Verander je later van gedachten? Geen probleem! <readMoreCookies>Hier</readMoreCookies> kun je je voorkeuren eenvoudig later aanpassen.",
      "mainDescriptionTitle": "Doel",
      "specificsDescriptionTitle": "Eigenschappen",
      "privacyDescriptionTitle": "Delen",
      "privacyDescriptionLinkLabel": "Privacy statement",
      "cookieCategories": {
        "standard": {
          "title": "Standaard",
          "description": "Dit pakket staat altijd aan. Zo werkt de basis van onze website goed, zoals producten toevoegen aan je winkelwagen."
        },
        "personalized": {
          "title": "Persoonlijk",
          "description": "Met marketingcookies krijg je een persoonlijke winkelervaring. We gebruiken cookies van derden om je voorkeuren te onthouden en voor advertenties die bij je passen."
        },
        "functional": {
          "title": "Functioneel",
          "description": "Dit pakket staat altijd aan. Zo werkt de basis van onze website goed, zoals producten toevoegen aan je winkelwagen.",
          "cookies": {
            "calendly": {
              "title": "Calendly",
              "mainDescription": "Maakt het plannen van afspraken (bijv. zakelijk advies) vanuit onze site mogelijk.",
              "specificsDescription": "Cookies/identifiers afkomstig van Calendly en  wordt na maximaal drie weken verwijderd.",
              "privacyDescription": "Calendly deelt geen anonieme data met derden."
            }
          }
        },
        "analytical": {
          "title": "Analytisch",
          "description": "Met deze cookies krijgen we inzicht in het gebruik van onze site via tools zoals Google Analytics. Daarmee verbeteren we jouw ervaring op onze website.",
          "cookies": {
            "googleAnalytics": {
              "title": "Google Analytics",
              "mainDescription": "Met behulp van Google Analytics krijgen we inzicht in hoe je de Coolblue website gebruikt en met Firebase de Coolblue app. Deze informatie stelt ons in staat om je te voorzien van een productkeuze die perfect aansluit bij jouw behoeften en om de website en app te verbeteren. Ook kunnen we je zo aanbiedingen tonen die speciaal voor jou zijn geselecteerd op onze website, in onze nieuwsbrief en via e-mails met tips op maat.",
              "specificsDescription": "Deze cookie komt van Google en wordt na maximaal twee jaar verwijderd.",
              "privacyDescription": "Google deelt anonieme data met derden."
            },
            "crazyEgg": {
              "title": "CrazyEgg",
              "mainDescription": "CrazyEgg houdt bij waar je op klikt op onze website. Hierdoor kunnen we onze pagina's optimaliseren, zodat we de meest relevante informatie tonen op de beste plekken. De cookie die CrazyEgg plaatst is om te kijken of je een nieuwe bezoeker of een terugkerende bezoeker bent.",
              "specificsDescription": "Deze cookie komt van CrazyEgg en wordt na uiterlijk vijf jaar verwijderd.",
              "privacyDescription": "CrazyEgg deelt geen informatie met derden."
            },
            "awin": {
              "title": "Awin",
              "mainDescription": "Deze cookie gebruiken we om onze Affiliate partners te belonen voor hun bijdrage aan de verkoop. Zo kunnen wij een click of aankoop koppelen aan een partner.",
              "specificsDescription": "Deze cookie komt van Awin en wordt na een jaar verwijderd.",
              "privacyDescription": "Awin deelt geen anonieme data met derden."
            },
            "topi": {
              "title": "Topi",
              "mainDescription": "We werken samen met Topi om onze zakelijke lease producten aan te bieden. We gebruiken URL-identifiers om de klantreis van deze producten te analyseren en waar mogelijk te verbeteren.",
              "specificsDescription": "Deze cookie is afkomstig van Coolblue.{{subsidiary}} en wordt na maximaal twee jaar verwijderd.",
              "privacyDescription": "We delen je informatie niet met derden."
            },
            "datadog": {
              "title": "Datadog",
              "mainDescription": "We gebruiken deze cookie om de prestaties van onze website en app te monitoren. Dit helpt ons om technische problemen snel op te lossen, zodat alles soepel blijft werken voor jou.",
              "specificsDescription": "Deze cookies zijn afkomstig van Datadog. De cookie wordt na elke interactie met 15 minuten verlengd, maar blijft nooit langer dan 4 uur in totaal bewaard.",
              "privacyDescription": "Datadog deelt geen anonieme gegevens met derden."
            }
          }
        },
        "marketing": {
          "title": "Marketing",
          "description": "Met marketingcookies krijg je een persoonlijke winkelervaring. We gebruiken cookies van derden om je voorkeuren te onthouden en voor advertenties die bij je passen.",
          "cookies": {
            "microsoftAdvertising": {
              "title": "Microsoft Advertising",
              "mainDescription": "Deze cookie ziet welke producten je bekijkt. Zo kunnen we je relevante advertenties tonen binnen Microsoft Advertising. Zonder deze cookies loop je persoonlijke aanbiedingen mis.",
              "specificsDescription": "Deze cookie wordt na 90 dagen verwijderd.",
              "privacyDescription": "Microsoft deelt anonieme data met derden."
            },
            "googleMarketingPixel": {
              "title": "Google Marketing pixel",
              "mainDescription": "Deze cookie ziet welke pagina's je bekijkt. Zo kunnen we je relevante advertenties tonen op onze (partner)sites. We kunnen bijhouden hoe vaak je een advertentie al hebt gezien, of je op advertenties klikt en of je bestellingen plaatst nadat je een advertentie hebt gezien of hierop hebt geklikt. Zonder deze cookie loop je persoonlijke aanbiedingen mis.",
              "specificsDescription": "Deze cookie komt van Google en wordt na maximaal 18 maanden verwijderd.",
              "privacyDescription": "Google deelt anonieme data met derden."
            },
            "meta": {
              "title": "Meta",
              "mainDescription": "Deze cookie ziet welke producten je bekijkt. Zo kunnen we je relevante advertenties tonen op Meta. Zonder deze cookies loop je persoonlijke aanbiedingen mis.",
              "specificsDescription": "Deze cookie komt van Meta en blijft maximaal 2 jaar bewaard.",
              "privacyDescription": "Meta deelt geen informatie met derden."
            },
            "snapchat": {
              "title": "Snapchat",
              "mainDescription": "Deze cookie ziet welke producten je bekijkt. Zo kunnen we je relevante advertenties tonen op Snapchat. Zonder deze cookies loop je persoonlijke aanbiedingen mis.",
              "specificsDescription": "Deze cookie komt van Snapchat en blijft maximaal 13 maanden bewaard.",
              "privacyDescription": "Snapchat deelt geen informatie met derden."
            },
            "linkedin": {
              "title": "Linkedin",
              "mainDescription": "Deze cookie ziet welke producten je bekijkt. Zo kunnen we je relevante advertenties tonen op LinkedIn. Zonder deze cookies loop je persoonlijke aanbiedingen mis.",
              "specificsDescription": "Deze cookie komt van LinkedIn en blijft maximaal 2 jaar bewaard.",
              "privacyDescription": "LinkedIn deelt geen informatie met derden."
            },
            "jobster": {
              "title": "Jobster",
              "mainDescription": "Deze cookie gebruiken we om onze een click of aankoop koppelen aan een bezoek die komt vanuit Jobster.",
              "specificsDescription": "Deze cookie komt van Jobster en wordt na een jaar verwijderd.",
              "privacyDescription": "Jobster deelt geen anonieme data met derden."
            },
            "tiktok": {
              "title": "TikTok",
              "mainDescription": "Deze cookie ziet welke producten je bekijkt. Zo kunnen we je relevante advertenties tonen op TikTok. Zonder deze cookies loop je persoonlijke aanbiedingen mis.",
              "specificsDescription": "Deze cookie komt van TikTok en blijft maximaal 13 maanden bewaard.",
              "privacyDescription": "TikTok deelt geen informatie met derden."
            },
            "reddit": {
              "title": "Reddit",
              "mainDescription": "Deze cookie ziet welke producten je bekijkt. Zo kunnen we je relevante advertenties tonen op Reddit. Zonder deze cookies loop je persoonlijke aanbiedingen mis.",
              "specificsDescription": "Deze cookie komt van Facebook en blijft maximaal 90 dagen bewaard.",
              "privacyDescription": "Reddit deelt geen informatie met derden."
            },
            "kevel": {
              "title": "Kevel",
              "mainDescription": "Met Kevel-identifiers kunnen we zien in welke producten je geïnteresseerd bent (of niet), zodat we je relevante advertenties kunnen tonen op onze website. Zonder Kevel-identifiers mis je persoonlijke aanbiedingen.",
              "specificsDescription": "Deze identifier is afkomstig van Kevel en wordt 1 jaar bewaard.",
              "privacyDescription": "Kevel deelt geen informatie met derden."
            }
          }
        }
      }
    },
    "footer": {
      "acceptAllButton": "Alles accepteren",
      "acceptSelectionButton": "Opslaan"
    }
  },
  "allCookiesForm": {
    "explanation": "Met cookies en technieken die daarop lijken helpen we je beter en persoonlijker. Dankzij functionele cookies werkt de website goed. Ze hebben ook een analytische functie. Zo maken we de website elke dag een beetje beter. We laten je graag persoonlijke advertenties zien. Daarom gebruiken we persoonlijke cookies zodat wij en derde partijen jouw gedrag binnen en buiten onze website kunnen volgen. Dat doen we op een anonieme manier. Meer weten? Lees <readMore>hier</readMore> alles over onze cookie- en privacyverklaring. Klik op 'Oké' om te accepteren. Kies je voor weigeren? Dan plaatsen we alleen functionele en beperkte analytische cookies en gebruiken we technieken die daarop lijken. Je kunt je voorkeuren later nog aanpassen op de voorkeuren pagina.",
    "acceptButton": "Oké",
    "declineButton": "Weigeren"
  },
  "categoryCookiesForm": {
    "explanation": "Om je beter en persoonlijker te helpen, gebruiken wij cookies en vergelijkbare technieken. Naast functionele cookies, waardoor de website goed werkt, gebruiken we ook analytische cookies om onze website elke dag weer een beetje beter te maken. Ook maken we gebruik van persoonlijke cookies zodat wij en derde partijen jouw internetgedrag kunnen volgen en persoonlijke advertenties kunnen laten zien. Meer weten? Lees <readMore>hier</readMore> alles over ons cookiebeleid. Hieronder kan je aangeven welke cookies jij wil accepteren.",
    "acceptAllButton": "Accepteer alle cookies",
    "acceptSelectedButton": "Accepteer geselecteerde cookies",
    "acceptSelectedCategoriesButton": "Keuze opslaan",
    "acceptSelectionButton": "Selectie accepteren",
    "denyAllButton": "Weigeren",
    "selectCookieCategoriesButton": "Zelf instellen",
    "cookieCategory": {
      "explanation": "Met functionele cookies zorgen we dat de website goed werkt. Die kun je daarom niet uitzetten. Analytische cookies gebruiken we om de website elke dag een beetje beter maken. Met persoonlijke cookies kunnen wij en derde partijen jouw internetgedrag volgen en persoonlijke advertenties laten zien.",
      "selectionExplanation": "Om je beter en persoonlijker te helpen, gebruiken wij cookies en vergelijkbare technieken. Naast functionele cookies, waardoor de website goed werkt, gebruiken we ook analytische cookies om onze website elke dag weer een beetje beter te maken. Ook maken we gebruik van persoonlijke cookies zodat wij en derde partijen jouw internetgedrag kunnen volgen en persoonlijke advertenties kunnen laten zien. Meer weten? Lees <readMore>hier</readMore> alles over ons cookiebeleid. Hieronder kan je aangeven welke cookies jij wil accepteren.",
      "title": "Mijn cookievoorkeuren",
      "functional": "Functionele",
      "analytical": "Analytische",
      "marketing": "Persoonlijke"
    }
  }
};

export default data;